/* @flow */

export const INTENT = {
  CAPTURE: ("capture": "capture"),
  AUTHORIZE: ("authorize": "authorize"),
  ORDER: ("order": "order"),
  TOKENIZE: ("tokenize": "tokenize"),
  SUBSCRIPTION: ("subscription": "subscription"),
};

export const COMMIT = {
  TRUE: (true: true),
  FALSE: (false: false),
};

export const VAULT = {
  TRUE: (true: true),
  FALSE: (false: false),
};

export const CURRENCY = {
  AED: ("AED": "AED"),
  AFN: ("AFN": "AFN"),
  ALL: ("ALL": "ALL"),
  AMD: ("AMD": "AMD"),
  ANG: ("ANG": "ANG"),
  ARS: ("ARS": "ARS"),
  AOA: ("AOA": "AOA"),
  AUD: ("AUD": "AUD"),
  AWG: ("AWG": "AWG"),
  AZN: ("AZN": "AZN"),
  BAM: ("BAM": "BAM"),
  BBD: ("BBD": "BBD"),
  BDT: ("BDT": "BDT"),
  BGN: ("BGN": "BGN"),
  BHD: ("BHD": "BHD"),
  BIF: ("BIF": "BIF"),
  BMD: ("BMD": "BMD"),
  BND: ("BND": "BND"),
  BOB: ("BOB": "BOB"),
  BRL: ("BRL": "BRL"),
  BSD: ("BSD": "BSD"),
  BTN: ("BTN": "BTN"),
  BWP: ("BWP": "BWP"),
  BZD: ("BZD": "BZD"),
  CAD: ("CAD": "CAD"),
  CDF: ("CDF": "CDF"),
  CHF: ("CHF": "CHF"),
  CLP: ("CLP": "CLP"),
  COP: ("COP": "COP"),
  CRC: ("CRC": "CRC"),
  CVE: ("CVE": "CVE"),
  CZK: ("CZK": "CZK"),
  DJF: ("DJF": "DJF"),
  DKK: ("DKK": "DKK"),
  DOP: ("DOP": "DOP"),
  DZD: ("DZD": "DZD"),
  EGP: ("EGP": "EGP"),
  ETB: ("ETB": "ETB"),
  ERN: ("ERN": "ERN"),
  EUR: ("EUR": "EUR"),
  FJD: ("FJD": "FJD"),
  FKP: ("FKP": "FKP"),
  GBP: ("GBP": "GBP"),
  GEL: ("GEL": "GEL"),
  GHS: ("GHS": "GHS"),
  GIP: ("GIP": "GIP"),
  GMD: ("GMD": "GMD"),
  GNF: ("GNF": "GNF"),
  GTQ: ("GTQ": "GTQ"),
  GYD: ("GYD": "GYD"),
  HKD: ("HKD": "HKD"),
  HNL: ("HNL": "HNL"),
  HRK: ("HRK": "HRK"),
  HTG: ("HTG": "HTG"),
  HUF: ("HUF": "HUF"),
  IDR: ("IDR": "IDR"),
  ILS: ("ILS": "ILS"),
  INR: ("INR": "INR"),
  ISK: ("ISK": "ISK"),
  JMD: ("JMD": "JMD"),
  JOD: ("JOD": "JOD"),
  JPY: ("JPY": "JPY"),
  KGS: ("KGS": "KGS"),
  KES: ("KES": "KES"),
  KHR: ("KHR": "KHR"),
  KMF: ("KMF": "KMF"),
  KRW: ("KRW": "KRW"),
  KWD: ("KWD": "KWD"),
  KYD: ("KYD": "KYD"),
  KZT: ("KZT": "KZT"),
  LAK: ("LAK": "LAK"),
  LKR: ("LKR": "LKR"),
  LRD: ("LRD": "LRD"),
  LSL: ("LSL": "LSL"),
  MAD: ("MAD": "MAD"),
  MDL: ("MDL": "MDL"),
  MGA: ("MGA": "MGA"),
  MKD: ("MKD": "MKD"),
  MNT: ("MNT": "MNT"),
  MOP: ("MOP": "MOP"),
  MRO: ("MRO": "MRO"),
  MRU: ("MRU": "MRU"),
  MUR: ("MUR": "MUR"),
  MVR: ("MVR": "MVR"),
  MWK: ("MWK": "MWK"),
  MXN: ("MXN": "MXN"),
  MYR: ("MYR": "MYR"),
  MZN: ("MZN": "MZN"),
  NAD: ("NAD": "NAD"),
  NGN: ("NGN": "NGN"),
  NIO: ("NIO": "NIO"),
  NOK: ("NOK": "NOK"),
  NPR: ("NPR": "NPR"),
  NZD: ("NZD": "NZD"),
  OMR: ("OMR": "OMR"),
  PAB: ("PAB": "PAB"),
  PEN: ("PEN": "PEN"),
  PGK: ("PGK": "PGK"),
  PHP: ("PHP": "PHP"),
  PKR: ("PKR": "PKR"),
  PLN: ("PLN": "PLN"),
  PYG: ("PYG": "PYG"),
  QAR: ("QAR": "QAR"),
  RON: ("RON": "RON"),
  RSD: ("RSD": "RSD"),
  RUB: ("RUB": "RUB"),
  RWF: ("RWF": "RWF"),
  SAR: ("SAR": "SAR"),
  SBD: ("SBD": "SBD"),
  SCR: ("SCR": "SCR"),
  SEK: ("SEK": "SEK"),
  SGD: ("SGD": "SGD"),
  SHP: ("SHP": "SHP"),
  SLE: ("SLE": "SLE"),
  SLL: ("SLL": "SLL"),
  SOS: ("SOS": "SOS"),
  SRD: ("SRD": "SRD"),
  STN: ("STN": "STN"),
  SVC: ("SVC": "SVC"),
  SZL: ("SZL": "SZL"),
  THB: ("THB": "THB"),
  TMT: ("TMT": "TMT"),
  TJS: ("TJS": "TJS"),
  TND: ("TND": "TND"),
  TOP: ("TOP": "TOP"),
  TTD: ("TTD": "TTD"),
  TWD: ("TWD": "TWD"),
  TZS: ("TZS": "TZS"),
  UAH: ("UAH": "UAH"),
  UGX: ("UGX": "UGX"),
  USD: ("USD": "USD"),
  UYU: ("UYU": "UYU"),
  UZS: ("UZS": "UZS"),
  VES: ("VES": "VES"),
  VND: ("VND": "VND"),
  VUV: ("VUV": "VUV"),
  WST: ("WST": "WST"),
  XAF: ("XAF": "XAF"),
  XCD: ("XCD": "XCD"),
  XOF: ("XOF": "XOF"),
  XPF: ("XPF": "XPF"),
  YER: ("YER": "YER"),
  ZAR: ("ZAR": "ZAR"),
  ZMW: ("ZMW": "ZMW"),
};
